import styled from 'styled-components';

import {
  CenteredLoader,
  Text as TextLayoutComponent,
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 100px;
    min-width: 800px;
    max-width: ${({ isfirstclicktestpage }) => (!isfirstclicktestpage && '800px')};
    overflow-x: ${({ isfirstclicktestpage }) => (isfirstclicktestpage ? 'unset' : 'auto')};

    @media screen and (max-width: 420px) {
      margin: 100px 30px 0px 30px;
      padding: 10px;
      width: 100vw;
      max-width: 100%;
      min-width: unset;
    }
  }
`;

export const ContainerProgressBar = styled.div`
  width: 200px;
  margin: 25px auto;
`;

const Text = styled(TextLayoutComponent)``;

const Title = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin: 25px auto 0;
    display: block;
    min-width: 130px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 30px 70px;
`;

const Loader = styled(CenteredLoader)``;

const Content = styled.div`
  padding: 30px 70px;

  @media screen and (max-width: 420px ) {
    padding: 30px 10px;
  };
`;

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export {
  Text,
  Title,
  Button,
  Container,
  Loader,
  Content,
  CenteredContainer,
};
